/**
 * KIDSpo｜読みもの記事（article.magazine）の補完スクリプト
 *
 * なぜ必要か:
 *   記事本文は Shopify 管理画面のエディタに手貼りする運用だが、保存時のサニタイズで
 *   `aria-labelledby` と `data-*` が剥がされることを実機で確認した（2026-08-06）。
 *   `id` / `class` / `<caption>` / `scope` / `role` / `tabindex` は保持される。
 *   結果、`role="region"` のスクロール領域・目次の <nav>・関連記事の <aside> が
 *   「名前のないランドマーク」になり、支援技術で用途が分からなくなる。
 *   本文HTMLに <script> は入れられない（エディタで壊れる）ため、テーマ側で名前を補う。
 *
 * やること（すべて「無いときだけ」補う。既にあるものは絶対に上書きしない）:
 *   1. .kidspo-art__scroll に、その中の <caption> の文言でアクセシブルネームを付ける
 *   2. 目次 <nav> / 関連記事 <aside> に、その見出しの文言で名前を付ける
 *   3. 横スクロールが発生していない表からは tabindex を外す（不要なタブ止まりを作らない）
 *   4. 見出しIDが失われていた場合だけ、本文HTML生成時と同じ規則で振り直す
 *      （build.js: h2 = kidspo-sNN 連番 / h3 = kidspo-sNN-n）
 */
(function () {
  'use strict';

  var root = document.querySelector('.article-template__content') || document.querySelector('main');
  if (!root) return;

  /** 要素にアクセシブルネームが既にあるか */
  function hasName(el) {
    if (el.getAttribute('aria-label')) return true;
    var ref = el.getAttribute('aria-labelledby');
    return !!(ref && document.getElementById(ref.split(/\s+/)[0]));
  }

  function nameFrom(el, text) {
    if (!text || hasName(el)) return;
    el.setAttribute('aria-label', text.replace(/\s+/g, ' ').trim());
  }

  // --- 1. 見出しID（失われていた場合のみ・build.js と同一の採番） ---
  var h2n = 0;
  var h3n = 0;
  Array.prototype.forEach.call(root.querySelectorAll('h2, h3'), function (h) {
    if (h.tagName === 'H2') {
      h2n += 1;
      h3n = 0;
      if (!h.id) h.id = 'kidspo-s' + (h2n < 10 ? '0' : '') + h2n;
    } else {
      h3n += 1;
      if (!h.id) h.id = 'kidspo-s' + (h2n < 10 ? '0' : '') + h2n + '-' + h3n;
    }
  });

  // --- 2. 横スクロールする表に名前を付け、不要な tabindex を外す ---
  Array.prototype.forEach.call(root.querySelectorAll('.kidspo-art__scroll'), function (box) {
    var cap = box.querySelector('caption');
    nameFrom(box, cap ? cap.textContent : '表');

    // はみ出していないならキーボードで止める必要がない（2.1.1 は「操作が必要なら到達できること」）
    var check = function () {
      var overflows = box.scrollWidth > box.clientWidth + 1;
      if (overflows) {
        if (!box.hasAttribute('tabindex')) box.setAttribute('tabindex', '0');
      } else if (box.getAttribute('tabindex') === '0') {
        box.removeAttribute('tabindex');
        box.removeAttribute('role');
      }
    };
    check();
    if (window.ResizeObserver) new ResizeObserver(check).observe(box);
    else window.addEventListener('resize', check, { passive: true });
  });

  // --- 3. 目次 / 関連記事のランドマークに名前を付ける ---
  var toc = root.querySelector('.kidspo-art__toc');
  if (toc) nameFrom(toc, (toc.querySelector('.kidspo-art__toc-h') || {}).textContent || '目次');

  var related = root.querySelector('.kidspo-art__related');
  if (related) nameFrom(related, (related.querySelector('.kidspo-art__related-h') || {}).textContent || 'あわせて読みたい');
})();
